import React from 'react';
import OrgAdminLayout from 'screens/organizations/components/OrgAdminLayout';
import PageLayout from 'components/PageLayout';
import PageSkeleton from 'components/PageSkeleton';
import EventList from 'components/Events';
import useOrganizationEvents from './hooks/useOrganizationEvents';

const OrganizationEvents = () => {
  const {
    data: { events, isLoading: isLoadingEvents, organization }
  } = useOrganizationEvents();

  if (isLoadingEvents) {
    return <PageSkeleton />;
  }

  return (
    <OrgAdminLayout>
      <PageLayout
        hidePageMenu
        isAdmin={organization?.isUserAdmin}
        isUserMember={organization?.isUserMember}
      >
        <EventList events={events?.items} isAdmin={organization.isUserAdmin} />
      </PageLayout>
    </OrgAdminLayout>
  );
};

export default OrganizationEvents;
